module.exports = __webpack_public_path__ + "static/18.2_Reformation_of_Christianity-ae3a00c42b6577766759071fe54f90f0.pdf";